import fastdom from 'fastdom';

import addClass from 'utils/add-class';
import transitionEnd from 'utils/transition-end';

export type Config = {
  classes?: string | string[];
  index?: number | null;
};

class Overlay {
  private readonly element: HTMLDivElement;

  private readonly classes: { base: string; active: string };

  private isActive: boolean;

  constructor() {
    this.classes = {
      base: 'overlay',
      active: 'overlay--active',
    };
    this.isActive = false;

    this.element = document.createElement('div');
    this.element.hidden = true;
    this.element.classList.add(this.classes.base);

    document.body.appendChild(this.element);

    this.toggle = this.toggle.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  toggle(): void {
    if (this.element.classList.contains(this.classes.active)) {
      this.hide();
    } else {
      this.show();
    }
  }

  show(options?: Config): void {
    if (this.isActive) {
      return;
    }

    this.isActive = true;
    this.element.hidden = false;

    if (options) {
      if (options.classes) {
        addClass(this.element, options.classes);
      }

      if (options.index) {
        this.element.style.zIndex = options.index.toString();
      }
    }

    fastdom.mutate(() => {
      this.element.classList.add(this.classes.active);
    });
  }

  hide(): void {
    if (!this.isActive) {
      return;
    }

    this.isActive = false;

    fastdom.mutate(() => {
      this.element.className = this.classes.base;

      transitionEnd(this.element, () => {
        if (!this.isActive) {
          this.element.hidden = true;
          this.element.style.zIndex = '';
        }
      });
    });
  }
}

const overlay = new Overlay();

export const { show, hide } = overlay;
